import React from 'react'
import { TeaserOfferSkeleton } from '../../../ui/skeleton/teaserOfferSkeleton'

interface OfferListLoaderProps {
  nbOffers?: number
}

export const OfferListLoader = ({ nbOffers = 5 }: OfferListLoaderProps) => (
  <ol className="sapce-y-4 md:space-y-8">
    {Array.from({ length: nbOffers }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={index}>
        <TeaserOfferSkeleton />
      </li>
    ))}
  </ol>
)
